<template>
  <layout-bigscreen nav_top="0">
    <div id="antdVue" ref="antdVue" :style="themeColorInit(themeColorConfig)" style="width:100%; height:100%;">
      <div class="antdVue">

        <div
          class="flex flex-direction flex-wrap align-stretch benben-flex-layout shujuzonglan_928_random_flex_0 w-100 bg-size-auto">
          <div class="flex align-stretch shujuzonglan_241_fd0_0 bg-c-fff w-100 bg-size-auto">
            <div class="flex flex-wrap align-center flex-sub  w-100">
              <div class="flex align-center shujuzonglan_977_fd0_0_c0_c1 w-100">
                <div
                  class="flex align-center flex-sub shujuzonglan_476_fd0_0_c0_c1_c0 mg-t-0 mg-r-20 mg-b-0 mg-l-0 w-100 bg-size-auto">
                  <img class='shujuzonglan_760_fd0_0_c0_c1_c0_c0 mg-t-0 mg-r-10 mg-b-0 mg-l-0'
                    :src="zaishou.shopimg" />
                  <div class="flex  flex-wrap align-center  w-100">
                    <span class="t-w-6 t-14">在售商品数</span>
                    <span class="t-20 t-w-6">{{zaishou.price}}</span>

                  </div>

                </div>
                <div class="flex align-center flex-sub shujuzonglan_476_fd0_0_c0_c1_c0 w-100 bg-size-auto">
                  <img class='shujuzonglan_760_fd0_0_c0_c1_c0_c0 mg-t-0 mg-r-10 mg-b-0 mg-l-0'
                    :src="jinrishang.shopimg" />
                  <div class="flex  flex-wrap align-center  w-100">
                    <span class="t-w-6 t-14">今日上架产品数</span>
                    <span class="t-20 t-w-6">{{jinrishang.price}}</span>

                  </div>

                </div>

              </div>
              <div class="flex align-center shujuzonglan_673_fd0_0_c0_c2 w-100">
                <div
                  class="flex align-center flex-sub shujuzonglan_476_fd0_0_c0_c1_c0 mg-t-0 mg-r-20 mg-b-0 mg-l-0 w-100 bg-size-auto">
                  <img class='shujuzonglan_760_fd0_0_c0_c1_c0_c0 mg-t-0 mg-r-10 mg-b-0 mg-l-0'
                    :src="zhuce.shopimg" />
                  <div class="flex  flex-wrap align-center  w-100">
                    <span class="t-w-6 t-14">注册用户数</span>
                    <span class="t-20 t-w-6">{{zhuce.price}}</span>

                  </div>

                </div>
                <div class="flex align-center flex-sub shujuzonglan_476_fd0_0_c0_c1_c0 w-100 bg-size-auto">
                  <img class='shujuzonglan_760_fd0_0_c0_c1_c0_c0 mg-t-0 mg-r-10 mg-b-0 mg-l-0'
                    :src="zuori.shopimg" />
                  <div class="flex  flex-wrap align-center  w-100">
                    <span class="t-w-6 t-14">昨日交易额</span>
                    <span class="t-20 t-w-6">{{zuori.price}}</span>

                  </div>

                </div>

              </div>

            </div>
            <div class="flex flex-direction flex-wrap align-stretch justify-center flex-sub  w-100">
              <div class="flex flex-wrap align-center justify-center  w-100">
                <span class="mg-t-20 mg-r-0 mg-b-30 mg-l-0 t-20 t-w-6">商品类目占比</span>

              </div>
              <div class="flex flex-wrap align-center  w-100">

                <benben-pie-ring class='shujuzonglan_213_random_fd0_0_c1_c1_c0 w-100'
                                 :field-options="catePie" data_source_type="1" chart_show_type="pie-ring"
                                 show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_2704"
                                 :chart-option="chartOptions_random_2568">

                </benben-pie-ring>


              </div>

            </div>
            <div class="flex flex-direction flex-wrap align-stretch justify-center flex-sub  w-100">
              <div class="flex flex-wrap align-center justify-center  w-100">
                <span class="mg-t-20 mg-r-0 mg-b-30 mg-l-0 t-20 t-w-6">会员级别占比</span>

              </div>
              <div class="flex flex-wrap align-center  w-100">

                <benben-pie-ring class='shujuzonglan_213_random_fd0_0_c1_c1_c0 w-100'
                                 :field-options="userLevelPie" data_source_type="1" chart_show_type="pie-ring"
                                 show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_4275"
                                 :chart-option="chartOptions_random_4957">

                </benben-pie-ring>


              </div>

            </div>
            <div class="flex flex-direction flex-wrap align-stretch justify-center flex-sub  w-100">
              <div class="flex flex-wrap align-center justify-center  w-100">
                <span class="mg-t-20 mg-r-0 mg-b-30 mg-l-0 t-20 t-w-6">商品销量</span>
              </div>
              <div class="flex flex-wrap align-center  w-100">
                <benben-line-simple class='shujuzonglan_213_random_fd0_0_c1_c1_c0 w-100'
                                    :field-options="goodsCountChart" data_source_type="1" chart_show_type="line-simple"
                                    show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_6490"
                                    :chart-option="chartOptions_random_8634">
                </benben-line-simple>


              </div>

            </div>

          </div>
          <div class="flex flex-wrap align-stretch justify-between shujuzonglan_640_fd0_1 w-100">
            <div
              class="flex flex-direction flex-wrap align-stretch flex-sub shujuzonglan_241_fd0_0 bg-c-fff mg-t-0 mg-r-10 mg-b-0 mg-l-0 w-100 bg-size-auto">
              <div class="flex  flex-wrap align-center shujuzonglan_874_fd0_1_c0_c0 w-100 t-22 t-w-6">
                <span>经营数据</span>
              </div>
              <div class="flex align-center flex-sub  w-100">
                <div class="flex flex-wrap align-center flex-sub  w-100">

                  <benben-pie-ring class='shujuzonglan_213_random_fd0_0_c1_c1_c0 w-100'
                                   :field-options="cateAmountChart" data_source_type="1" chart_show_type="pie-ring"
                                   show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_7157"
                                   :chart-option="chartOptions_random_1138">
                  </benben-pie-ring>
                </div>
                <div class="flex flex-wrap align-center flex-sub  w-100">

                  <benben-line-match-bar class='shujuzonglan_698_random_fd0_1_c0_c1_c1_c0 w-100'
                                         :field-options="orderAmountChart" data_source_type="1" chart_show_type="line-match-bar"
                                         show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_1225"
                                         :chart-option="chartOptions_random_9245">

                  </benben-line-match-bar>


                </div>

              </div>

            </div>
            <div
              class="flex align-stretch justify-between flex-sub shujuzonglan_151_fd0_1_c1 bg-c-fff w-100 bg-size-auto">
              <div class="flex flex-direction flex-wrap align-stretch flex-sub shujuzonglan_874_fd0_1_c0_c0 t-22 t-w-6">
                <span class="shujuzonglan_846_fd0_1_c1_c0_c0">总金额</span>
                <div class="flex align-center  w-100">
                  <div class="flex flex-direction flex-wrap align-stretch  mg-t-0 mg-r-10 mg-b-0 mg-l-0 w-20">
                    <div class="flex align-center flex-sub shujuzonglan_476_fd0_0_c0_c1_c0 w-100 bg-size-auto">
                      <div class="flex flex-direction flex-wrap align-stretch  w-100">
                        <span class="t-w-6 t-14">总销售额</span>
                        <span class="shujuzonglan_581_fd0_1_c1_c0_c1_c0_c0_c0_c1 t-20 t-w-6">{{totalOrderMount.allprice}}</span>

                      </div>

                    </div>
                    <div class="flex align-center flex-sub shujuzonglan_936_fd0_1_c1_c0_c1_c0_c1 w-100 bg-size-auto">
                      <div class="flex flex-direction flex-wrap align-stretch  w-100">
                        <span class="t-w-6 t-14">总单量</span>
                        <span class="shujuzonglan_581_fd0_1_c1_c0_c1_c0_c0_c0_c1 t-20 t-w-6">{{totalOrderMount.allnum}}</span>

                      </div>

                    </div>

                  </div>
                  <div class="flex flex-wrap align-center flex-sub  w-100">

                    <benben-line-simple class='shujuzonglan_581_random_fd0_1_c1_c0_c1_c1_c0'
                                        :field-options="orderAmountChart2" data_source_type="1" chart_show_type="line-simple"
                                        show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_4724"
                                        :chart-option="chartOptions_random_2260">

                    </benben-line-simple>


                  </div>

                </div>

              </div>

            </div>

          </div>
          <div class="flex align-stretch justify-between shujuzonglan_928_fd0_2 bg-c-fff w-100 bg-size-auto">
            <div class="flex flex-wrap align-stretch justify-between shujuzonglan_906_fd0_2_c0 bg-c-fff bg-size-auto">
              <div class="flex flex-direction flex-wrap align-stretch flex-sub shujuzonglan_874_fd0_1_c0_c0 t-22 t-w-6">
                <span class="shujuzonglan_846_fd0_1_c1_c0_c0 t-ct">注册曲线</span>
                <div class="flex flex-wrap align-center flex-sub  w-100">

                  <benben-pie-ring class='shujuzonglan_698_random_fd0_1_c0_c1_c1_c0 w-100'
                                   :field-options="userSourcePie" data_source_type="1" chart_show_type="pie-ring"
                                   show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_1541"
                                   :chart-option="chartOptions_random_5197">

                  </benben-pie-ring>


                </div>

              </div>

            </div>
            <div class="flex flex-wrap align-center flex-sub">

              <benben-line-simple class='shujuzonglan_698_random_fd0_1_c0_c1_c1_c0 w-100'
                                  :field-options="userAxis" data_source_type="1" chart_show_type="line-simple"
                                  show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_5714"
                                  :chart-option="chartOptions_random_8993">
              </benben-line-simple>
            </div>

          </div>

        </div>

      </div>
    </div>
  </layout-bigscreen>
</template>
<script>
  import {
    bigScreenMixins,
    receiveNew
  } from '@/assets/diypaaspc/diy-generate-big-screen-new.js'
  import {
    receive,
    benbenSelectDiy,
    benbenFlexNumberBox,
    scrollList,
    treeSelect,
    simpleSelect,
    multipleSelect,
    cascaderForm,
    checkboxForm,
    switchForm,
    messageReply,
    rangePicker,
    handSignature,
    mixinAddTableItem,
    editorForm,
    qiunDataCharts,
    copyText,
    mixinTableItemChange,
    in_array,
    themeColorInit,
    getUrlKey,
    clearDataPass,
    isEmpty,
    treeEdit
  } from '@/assets/diypaaspc/diy-pass-pc.js'
  import {
    provinceForm
  } from '@/assets/diypaaspc/province_area.js'
  import request from '@/utils/request'
  import * as echarts from 'echarts'
  import 'echarts-gl'
  import 'echarts-liquidfill'
  import {
    mapdata
  } from '@/assets/diypaaspc/mapdata.js'
  import layoutBigscreen from "@/components/layoutBigscreen"
  import {dataOverview, homeAllResult} from "@/api/statistics/home";
  import {goodsCateAmountPie, goodsCatePie} from "@/api/statistics/goods";
  import {userAxis, userLevel, userSource} from "@/api/statistics/user";
  import {orderAmountChart} from "@/api/statistics/order";

  export default {
    name: 'shujuzonglan',
    components: {
      layoutBigscreen
    },
    mixins: [bigScreenMixins],
    data() {
      const themeColorConfig = {
        "presetApi": {
          "getClassifyOne": "",
          "getClassifyTow": "",
          "getClassifyShop": ""
        },
        "themeType": 0,
        "themeConfig": [{
          "colorConfig": ["#333333", "#666666", "#999999", "#ffffff", "#0052c7", "#F02325", "#FC9C3A", "#4DC777",
            "#F2CC98", "#F2CC66"
          ],
          "bgColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#FC9fff", "#E6F333", "#E6F1FE",
            "linear-gradient(301deg, #EBBA7B 0%, #F8D9AD 100%)",
            "linear-gradient(180deg, #F5588E 0%, #F0403C 100%)",
            "linear-gradient(179deg, #FFD033 0%, #F4890E 100%)"
          ],
          "bdColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#333333", "#666666", "#999999",
            "#dddddd", "#1178F0", "#F02325"
          ]
        }]
      };
      receive(this);
      receiveNew(this);
      return {
        totalOrderMount:{
          allprice: 200, // 总利润
          allnum: 800 // 总单量
        }, // 新增用户
        zaishou:{
          shopimg: require('@/assets/images/dataoverview/onsalegoods.png'),
          price: '200'
        },
        jinrishang:{
          shopimg: require('@/assets/images/dataoverview/todaySale.png'),
          price: '200'
        }, // 今日上架产品数
        zhuce:{
          shopimg: require('@/assets/images/dataoverview/registeruser.png'),
          price: '200'
        }, // 注册用户数
        zuori:{
          shopimg: require('@/assets/images/dataoverview/orderAmount.png'),
          price: '200'
        }, // 昨日交易额
        themeColorConfig,
        mapdata: mapdata,
        "current_index": "0",
        "iframe_list": [],
        "Timer": {},
        "total": 1,
        "isFullScreen": false,
        "big_screen_global_query": {
          "screen_global_time_range_type": "5",
          "screen_global_time_custom_time": "",
          "screen_global_dept": "",
          "screen_global_user": "",
          "diy_api_time": ""
        },
        "saizhuge_api_loaded": false,
        "amount": {
          "price": "",
          "onbasis": "",
          "linkratio": ""
        },
        "payOrderCount": {
          "price": "",
          "onbasis": "",
          "linkratio": ""
        },
        "payUserCount": {
          "price": "",
          "onbasis": "",
          "linkratio": ""
        },
        "zhuanHua": {
          "price": "",
          "onbasis": "",
          "linkratio": ""
        },
        "customerPrice": {
          "price": "",
          "onbasis": "",
          "linkratio": ""
        },
        "jundan": {
          "price": "",
          "onbasis": "",
          "linkratio": ""
        },
        "viewSource": "PC",
        "big_screen_global_config": {
          "is_screen_global_time": false,
          "is_screen_global_dept": false,
          "is_screen_global_user": false
        },
        "theme_color_5714": ["rgba(92, 134, 229, 1)", "#0F36A2", "rgba(45, 60, 152, 1)", "#F27B60", "#F8A200",
          "#B0D630", "#6EC890", "#6AE7E6", "#FC658A"
        ],
        "chartOptions_random_8993": {
          "tooltip": {
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "grid": {
            "left": "1%",
            "right": "2%",
            "bottom": "0%",
            "top": "15%",
            "containLabel": true
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(10, 10, 36, 1)"
              }
            }
          },
          "yAxis": {
            "type": "value",
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            }
          },
          "seriesSetting": {
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "data": [],
              "lineStyle": {
                "type": "dashed"
              },
              "label": {
                "color": "#fff"
              },
              "symbol": "none"
            },
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            },
            "smooth": true,
            "symbol_icon": "roundRect",
            "symbol": "roundRect",
            "showAllSymbol": true,
            "symbolSize": [10, 10]
          }
        },
        userAxis: {
          "xAxis": {
            "data": ["2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20"]
          },
          "series": [{
            "name": "日用户增长",
            "data": [19, 57, 46, 80, 27],
            "type": "line"
          }]
        }, // 折线图
        "theme_color_1541": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_5197": {
          "seriesSetting": {
            "center": ["50%", "50%"],
            "radius": ["30%", "50%"],
            "itemStyle": {
              "borderColor": "",
              "borderWidth": "",
              "borderRadius": ""
            },
            "startAngle": "",
            "type": "pie",
            "label": {
              "color": "#fff"
            }
          },
          "labelSetting": {
            "label": {
              "color": "rgba(10, 10, 36, 1)",
              "show": true,
              "emphasis": {
                "show": true,
                "textStyle": {
                  "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "symbol_icon": "roundRect",
            "icon": "roundRect",
            "format": "{b}"
          },
          "tooltip": {
            "show": true,
            "autoToolTip": false,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          }
        },
        userSourcePie: {
          "series": [{
            "data": [{
              "value": 1335,
              "name": "安卓APP"
            }, {
              "value": 1310,
              "name": "IOSAPP"
            }]
          }]
        }, // 注册曲线 饼状图
        "theme_color_4724": ["rgba(92, 134, 229, 1)", "#0F36A2", "rgba(45, 60, 152, 1)", "#F27B60", "#F8A200",
          "#B0D630", "#6EC890", "#6AE7E6", "#FC658A"
        ],
        "chartOptions_random_2260": {
          "tooltip": {
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "grid": {
            "left": "1%",
            "right": "2%",
            "bottom": "0%",
            "top": "15%",
            "containLabel": true
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(10, 10, 36, 1)"
              }
            }
          },
          "yAxis": {
            "type": "value",
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            }
          },
          "seriesSetting": {
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "data": [],
              "lineStyle": {
                "type": "dashed"
              },
              "label": {
                "color": "#fff"
              },
              "symbol": "none"
            },
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            },
            "smooth": true,
            "symbol_icon": "roundRect",
            "symbol": "roundRect",
            "showAllSymbol": true,
            "symbolSize": [10, 10]
          }
        },
        orderAmountChart2: {
          "xAxis": {
            "data": ["2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20"]
          },
          "series": [{
            "name": "销售额",
            "data": [19, 57, 46, 80, 27],
            "type": "line"
          }]
        }, // 新增用户 折现图
        "theme_color_1225": ["rgba(92, 134, 229, 1)", "rgba(106, 188, 197, 1)", "#F8A200", "#B0D630", "#6EC890",
          "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"
        ],
        "chartOptions_random_9245": {
          "tooltip": {
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "backgroundColor": "rgba(50,50,50,0.7)",
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            },
            "show": false
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "symbol_icon": "roundRect",
            "icon": "roundRect"
          },
          "grid": {
            "left": "1%",
            "right": "2%",
            "bottom": "0%",
            "top": "15%",
            "containLabel": true
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(10, 10, 36, 1)"
              }
            }
          },
          "yAxis": [{
            "type": "value",
            "name": "交易金额",
            "position": "left",
            "alignTicks": true,
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "formatter": "{value} ",
              "color": "rgba(10, 10, 36, 1)"
            },
            "splitLine": {
              "show": false
            }
          }, {
            "type": "value",
            "name": "支付下单数量",
            "position": "right",
            "alignTicks": true,
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "formatter": "{value}",
              "color": "rgba(10, 10, 36, 1)"
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            }
          }],
          "barSetting": {
            "barWidth": 10,
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            },
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "label": {
                "color": "#fff"
              },
              "symbol": "none",
              "lineStyle": {
                "type": "dashed"
              },
              "data": []
            }
          },
          "seriesSetting": {
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "data": [],
              "lineStyle": {
                "type": "dashed"
              },
              "label": {
                "color": "#fff"
              },
              "symbol": "none"
            },
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            }
          }
        },
        orderAmountChart: {
          "xAxis": {
            "data": ["2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20"]
          },
          "series": [{
            "name": "支付下单数量",
            "type": "bar",
            "yAxisIndex": 1,
            "barWidth": 10,
            "itemStyle": {
              "borderRadius": [5, 5, 5, 5]
            },
            "data": [2500, 2900, 3200, 3600, 4100, 4800, 5500]
          }, {
            "name": "交易金额",
            "type": "line",
            "yAxisIndex": 0,
            "data": [50, 55, 60, 65, 70, 75, 80]
          }]
        }, // 经营数据 柱状图加折线图
        "theme_color_7157": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_1138": {
          "seriesSetting": {
            "center": ["50%", "50%"],
            "radius": ["30%", "50%"],
            "itemStyle": {
              "borderColor": "",
              "borderWidth": "",
              "borderRadius": ""
            },
            "startAngle": "",
            "type": "pie",
            "label": {
              "color": "#fff"
            }
          },
          "labelSetting": {
            "label": {
              "color": "rgba(10, 10, 36, 1)",
              "show": true,
              "emphasis": {
                "show": true,
                "textStyle": {
                  "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "symbol_icon": "roundRect",
            "icon": "roundRect",
            "format": "{b}"
          },
          "tooltip": {
            "show": true,
            "autoToolTip": false,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          }
        },
        cateAmountChart: {
          "series": [{
            "data": [{
              "value": 1335,
              "name": "首饰"
            }, {
              "value": 1310,
              "name": "耳饰"
            }, {
              "value": 1234,
              "name": "手链"
            }, {
              "value": 1350,
              "name": "装修"
            }, {
              "value": 1548,
              "name": "14k金"
            }]
          }]
        }, // 经营数据 饼状图
        "theme_color_6490": ["rgba(92, 134, 229, 1)", "#0F36A2", "rgba(45, 60, 152, 1)", "#F27B60", "#F8A200",
          "#B0D630", "#6EC890", "#6AE7E6", "#FC658A"
        ],
        "chartOptions_random_8634": {
          "tooltip": {
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "grid": {
            "left": "1%",
            "right": "2%",
            "bottom": "0%",
            "top": "15%",
            "containLabel": true
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(10, 10, 36, 1)"
              }
            }
          },
          "yAxis": {
            "type": "value",
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            }
          },
          "seriesSetting": {
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "data": [],
              "lineStyle": {
                "type": "dashed"
              },
              "label": {
                "color": "#fff"
              },
              "symbol": "none"
            },
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            },
            "smooth": true,
            "symbol_icon": "roundRect",
            "symbol": "roundRect",
            "showAllSymbol": true,
            "symbolSize": [10, 10]
          }
        },
        goodsCountChart: {
          xAxis: {
            data: ["2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20"]
          },
          series: [{
            name: "累计数量",
            data: [19, 57, 46, 80, 27],
            type: "line"
          }]
        },
        "theme_color_4275": ["rgba(36, 120, 242, 1)", "rgba(132, 183, 249, 1)", "rgba(95, 156, 248, 1)",
          "rgba(206, 229, 252, 1)", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"
        ],
        "chartOptions_random_4957": {
          "seriesSetting": {
            "center": ["50%", "50%"],
            "radius": ["30%", "50%"],
            "itemStyle": {
              "borderColor": "",
              "borderWidth": "",
              "borderRadius": ""
            },
            "startAngle": "",
            "type": "pie",
            "label": {
              "color": "#fff"
            }
          },
          "labelSetting": {
            "label": {
              "color": "rgba(10, 10, 36, 1)",
              "show": true,
              "emphasis": {
                "show": true,
                "textStyle": {
                  "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "symbol_icon": "roundRect",
            "icon": "roundRect",
            "format": "{b}"
          },
          "tooltip": {
            "show": true,
            "autoToolTip": false,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          }
        },
        userLevelLine: {
          "series": [{
            "data": [{
              "value": 1335,
              "name": "青铜"
            }, {
              "value": 1310,
              "name": "白银"
            }, {
              "value": 1234,
              "name": "黄金"
            }, {
              "value": 1350,
              "name": "铂金"
            }, {
              "value": 1548,
              "name": "钻石"
            }]
          }]
        }, // 会员级别占比
        "theme_color_2704": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "chartOptions_random_2568": {
          "seriesSetting": {
            "center": ["50%", "50%"],
            "radius": ["30%", "50%"],
            "itemStyle": {
              "borderColor": "",
              "borderWidth": "",
              "borderRadius": ""
            },
            "startAngle": "",
            "type": "pie",
            "label": {
              "color": "#fff"
            }
          },
          "labelSetting": {
            "label": {
              "color": "rgba(10, 10, 36, 1)",
              "show": true,
              "emphasis": {
                "show": true,
                "textStyle": {
                  "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "symbol_icon": "roundRect",
            "icon": "roundRect",
            "format": "{b}"
          },
          "tooltip": {
            "show": true,
            "autoToolTip": false,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          }
        },
        catePie: {
          "series": [{
            "data": [{
              "value": 1335,
              "name": "首饰"
            }, {
              "value": 1310,
              "name": "耳饰"
            }, {
              "value": 1234,
              "name": "手链"
            }, {
              "value": 1350,
              "name": "装修"
            }, {
              "value": 1548,
              "name": "14k金"
            }]
          }]
        } // 商品类目占比
      };

    },
    filters: {},
    created() {
      if (getUrlKey('viewSource')) {
        this.viewSource = getUrlKey('viewSource');
      }
      //this.get_url_list()
      //查询在售商品数 今日上架产品数 这个
      this.getDataOverview()
      //商品分类占比
      this.getCatePie()
      this.getCateAmountPie()
      //用户等级
      this.getUserLevel()
      //用户等级
      this.getUserSource()
      //订单金额统计
      this.getAmountChart()
      //总金额统计
      this.getHomeAllStatistics()
      //日用户增长
      this.getUserAxis()
    },
    mounted() {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      copyText,
      mixinTableItemChange,
      in_array,
      themeColorInit,
      isEmpty,
      getDataOverview() {
        dataOverview().then(response => {
          this.zaishou.price = response.data.goodsOnSaleTotalCount
          this.jinrishang.price = response.data.goodsOnSaleTodayCount
          this.zhuce.price = response.data.userCount
          this.zuori.price = response.data.payAmountYesterday
        })
      },
      getCatePie() {
        goodsCatePie().then(response => {
          this.catePie={"series": [{"data": response.data}] }
        })
      },
      getCateAmountPie() {
        goodsCateAmountPie().then(response => {
          this.cateAmountChart={"series": [{"data": response.data}] }
        })

      },


      getUserLevel() {
        userLevel().then(response => {
          this.userLevelPie={"series": [{"data": response.data}] }
        })
      },
      getUserSource() {
        userSource().then(response => {
          this.userSourcePie={"series": [{"data": response.data}] }
        })
      },
      getAmountChart() {
        let orderAmountParam = {
          chartType: 'days',
          dateRange: [],
          startTime: undefined,
          endTime: undefined,
        }
        orderAmountChart(orderAmountParam).then(response => {
          this.goodsCountChart = {
            xAxis: {
              data: response.data.xxAxis
            },
            series: [{
              name: "累计数量",
              data: response.data.yyAxis.goodsCountList || [],
              type: "line"
            }]
          }
          this.orderAmountChart = {
            xAxis: {
              data: response.data.xxAxis
            },
            series: [{
              "name": "支付下单数量",
              "type": "bar",
              "yAxisIndex": 1,
              "barWidth": 10,
              "itemStyle": {
                "borderRadius": [5, 5, 5, 5]
              },
              "data": response.data.yyAxis.orderCountList || []
            }, {
              "name": "交易金额",
              "type": "line",
              "yAxisIndex": 0,
              "data": response.data.yyAxis.payAmountList || []
            }]
          }
          this.orderAmountChart2 = {
            xAxis: {
              data: response.data.xxAxis
            },
            series: [ {
              "name": "销售额",
              "type": "line",
              "data": response.data.yyAxis.payAmountList || []
            }]
          }

        })
      },
      getUserAxis() {
        let orderAmountParam = {
          chartType: 'days',
          dateRange: [],
          startTime: undefined,
          endTime: undefined,
        }
        userAxis(orderAmountParam).then(response => {
          this.userAxis = {
            xAxis: {
              data: response.data.xxAxis
            },
            series: [{
              name: "日用户增长",
              data: response.data.yyAxis.userCountList || [],
              type: "line"
            }]
          }
        })
      },
      getHomeAllStatistics() {
        homeAllResult({}).then(response => {
          this.totalOrderMount.allnum = response.data.orderCount
          this.totalOrderMount.allprice = response.data.orderAmount
        });
      },

      //自动轮播展示页面
      change_page() {
        var that = this;
        that.Timer = setInterval(function() {
          that.$refs['iframeBox_' + that.current_index][0].contentWindow.postMessage({
            ident: 'open_mute',
            open: false
          }, '*')
          that.current_index = (that.current_index + 1) % that.iframe_list.length;
          console.log(that.current_index, 'that.current_index')
          that.$refs['iframeBox_' + that.current_index][0].contentWindow.postMessage({
            ident: 'open_mute',
            open: true
          }, '*')
          that.total += 1;
        }, 10000)
      },
      //获取轮播页面列表
      get_url_list() {
        this.iframe_list = []
        //this.iframe_list =[{"url":" /spread/general/index?view_name=shujuzichanjiankongjiashicang","dapingzhuti":"领导驾驶舱"},
        //{"url":" /spread/general/index?view_name=jiaoxuegaikuangjiashicang","dapingzhuti":"教学概况驾驶舱"}];

        this.change_page()
      },
      //清除轮播计时器
      clearTimerFunc() {
        if (this.Timer) {
          clearInterval(this.Timer)
          this.Timer = null
        }
      },
      //统一获取自定义接口
      get_diy_api_page() {

      }

    }
  }
</script>
<style lang="less" scoped>
  /* External CSS is loaded in index.html to prevent style flickering */
  @import '../../assets/diypaaspc/diy-pass-pc.css';
  @import '../../assets/diypaaspc/diy-pass-big-screen.css';
  @import '../../assets/diypaaspc/library-ant-design-vue.css';

  .antdVue {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .zoom_bg_color {
    background: #fff;
  }

  #antdVue .shujuzonglan_928_random_flex_0 {
    background: #eee;
    min-height: 100vh;
    padding: 24px;
  }

  #antdVue .shujuzonglan_906_fd0_2_c0 {
    width: 30%;
  }

  #antdVue .shujuzonglan_928_fd0_2 {
    margin: 15px 0px 0px 0px;
    padding: 12px;
    border-radius: 16px;
  }

  #antdVue .shujuzonglan_581_random_fd0_1_c1_c0_c1_c1_c0 {
    width: 80%;
    height: 260px;
  }

  #antdVue .shujuzonglan_936_fd0_1_c1_c0_c1_c0_c1 {
    background: #ECF8FF;
    padding: 17px 24px 28px 12px;
    border-radius: 8px;
    margin: 12px 0px 0px 0px;
  }

  #antdVue .shujuzonglan_581_fd0_1_c1_c0_c1_c0_c0_c0_c1 {
    margin: 12px 0px 0px 0px;
  }

  #antdVue .shujuzonglan_846_fd0_1_c1_c0_c0 {
    margin: 0px 0px 8px 0px;
  }

  #antdVue .shujuzonglan_151_fd0_1_c1 {
    padding: 12px;
    border-radius: 16px;
  }

  #antdVue .shujuzonglan_698_random_fd0_1_c0_c1_c1_c0 {
    height: 260px;
  }

  #antdVue .shujuzonglan_874_fd0_1_c0_c0 {
    margin: 0px 0px 12px 0px;
  }

  #antdVue .shujuzonglan_640_fd0_1 {
    margin: 15px 0px 0px 0px;
  }

  #antdVue .shujuzonglan_213_random_fd0_0_c1_c1_c0 {
    height: 290px;
  }

  #antdVue .shujuzonglan_673_fd0_0_c0_c2 {
    margin: 14px 0px 0px 0px;
  }

  #antdVue .shujuzonglan_760_fd0_0_c0_c1_c0_c0 {
    width: 67px;
    height: 67px;
    border-radius: 0px 0px 0px 0px;
  }

  #antdVue .shujuzonglan_476_fd0_0_c0_c1_c0 {
    background: #ECF8FF;
    padding: 17px 24px 28px 12px;
    border-radius: 8px;
  }

  #antdVue .shujuzonglan_977_fd0_0_c0_c1 {
    margin: 17px 0px 0px 0px;
  }

  #antdVue .shujuzonglan_630_fd0_0_c0_c0_c1 {
    margin: 0px 0px 0px 17px;
  }

  #antdVue .shujuzonglan_521_fd0_0_c0_c0_c0 {
    width: 85px;
    height: 85px;
    border-radius: 85px;
  }

  #antdVue .shujuzonglan_241_fd0_0 {
    border-radius: 16px;
    padding: 12px;
  }

  #antdVue .benben-iframe-box {
    left: 0;
    top: 0;
  }
</style>